"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.createAction = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/typeof"));

var isEvent = function isEvent(data) {
  return data && (0, _typeof2.default)(data) === 'object' && 'nativeEvent' in data || data instanceof Event;
};

var createAction = function createAction(type, dispatch, meta) {
  return function (payload) {
    if (isEvent(payload)) {
      // It is not uncommon for redux actions to be bound to event handlers but they should not be exposed as event payloads
      payload = undefined;
    }

    return dispatch({
      type: type,
      payload: payload,
      meta: meta
    });
  };
};

exports.createAction = createAction;